import React from "react";

export default function AppTabs({
  items = [],
  activeKey,
  onChange,
  variant = "page",
  className = "",
  ...props
}) {
  const classes = [
    "ds-tabs",
    variant === "page" ? "ds-tabs--page" : "",
    variant === "contained" ? "ds-tabs--contained" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} role="tablist" {...props}>
      {items.map((item) => {
        const key = typeof item === "string" ? item : item.key;
        const label = typeof item === "string" ? item : item.label;
        const isActive = key === activeKey;

        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={isActive ? "true" : "false"}
            className={`ds-tabs__item${isActive ? " is-active" : ""}`}
            onClick={() => {
              if (onChange) {
                onChange(key, item);
              }
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
